<form (submit)="saveAndNext()" [formGroup]="form" (keydown.enter)="saveAndNext()" class="main-form">
  <div class="card mb-4">
    <div class="card-header">
      <fa-icon [icon]="faPlane"></fa-icon> {{ "FLIGHT_BRIEF.AIRCRAFT" | translate }}
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group mb-0">
            <label
              for="countryCode"
              [innerText]="'FLIGHT_BRIEF.AIRLINE' | translate"
            ></label>
            <app-airline-autocomplete
              (setValueToFormControl)="setValueToFormControl($event)"
              inputName="airlineId"
                            [defaultValue]="
                                airlineId.value && airlinesObj[airlineId.value]
                                    ? airlinesObj[airlineId.value]
                                    : null
                            "
              [disabled]="form.disabled"
              [placeholder]="'AIRLINES.LIST.SEARCH_PLACEHOLDER' | translate"
              [noMargin]="true"
            ></app-airline-autocomplete>

            <div class="invalid-tooltip">
              @if (
                (form.touched || airlineId.touched) &&
                airlineId.errors &&
                airlineId.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
        @if (airlineId.value) {
          <div class="col-md-4">
            <div class="form-group">
              <label
                for="aircraftModelId"
                [innerText]="'FLIGHT_BRIEF.AIRCRAFT' | translate"
              ></label>
              @if (loadingAircraftsCompiled) {
                <div class="placeholder w-100"></div>
              }
              @if (!loadingAircraftsCompiled && !aircraftModels.length) {
                <div
                  class="alert alert-warning alert-sm text-center"
                  [innerText]="'GENERAL.NO_DATA_TO_DISPLAY' | translate"
                ></div>
              }
              @if (!loadingAircraftsCompiled && aircraftModels.length) {
                <select
                  class="form-select"
                  id="aircraftModelId"
                  formControlName="aircraftModelId"
                            [class.is-invalid]="
                                (form.touched || aircraftModelId.touched) &&
                                aircraftModelId.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
                  (change)="updatedAircraftModelId()"
                  >
                  <option
                    [ngValue]="null"
                    [innerText]="'GENERAL.PLEASE_SELECT_ONE' | translate"
                  ></option>
                  @for (aircraftModel of aircraftModels; track aircraftModel.id ?? aircraftModel.title) {
                    <option
                      [value]="aircraftModel.id"
                      [innerText]="aircraftModel.title"
                    ></option>
                  }
                </select>
              }
              <div class="invalid-tooltip">
                @if (
                  (form.touched || aircraftModelId.touched) &&
                  aircraftModelId.errors &&
                  aircraftModelId.errors['required']
                  ) {
                  <div
                    [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                  ></div>
                }
              </div>
            </div>
          </div>
        }
        @if (aircraftModelId.value) {
          <div class="col-md-4">
            <div class="form-group">
              <label for="aircraftId">
                <span [innerText]="'FLIGHT_BRIEF.REGISTRATION' | translate"></span>
                @if (hasAclAccess(EnumAcl.aircraftsAdd)) {
                  <button
                    type="button"
                    (click)="openAircraftAddModal()"
                    class="btn btn-icon"
                    [disabled]="loadingAircrafts"
                    >
                    <fa-icon [icon]="faCirclePlus"></fa-icon>
                  </button>
                }
              </label>
              @if (loadingAircrafts) {
                <div class="placeholder w-100"></div>
              }
              @if (!loadingAircrafts && !aircrafts.length) {
                <div
                  class="alert alert-warning alert-sm text-center"
                  [innerText]="'GENERAL.NO_DATA_TO_DISPLAY' | translate"
                ></div>
              }
              @if (!loadingAircrafts && aircrafts.length) {
                <select
                  class="form-select"
                  id="aircraftId"
                  formControlName="aircraftId"
                            [class.is-invalid]="
                                (form.touched || aircraftId.touched) &&
                                aircraftId.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
                  (change)="updatedAircraftId()"
                  >
                  <option
                    [ngValue]="null"
                    [innerText]="'GENERAL.PLEASE_SELECT_ONE' | translate"
                  ></option>
                  @for (aircraft of aircrafts; track aircraft.id) {
                    <option
                      [value]="aircraft.id"
                                [innerText]="
                                    aircraft.registration !== ''
                                        ? aircraft.registration
                                        : ('FLIGHT_BRIEF.REGISTRATION_UNKNOWN' | translate) +
                                          ' (id: ' +
                                          aircraft.id +
                                          ')'
                                "
                    ></option>
                  }
                </select>
              }
              <div class="invalid-tooltip">
                @if (
                  (form.touched || aircraftId.touched) &&
                  aircraftId.errors &&
                  aircraftId.errors['required']
                  ) {
                  <div
                    [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                  ></div>
                }
              </div>
            </div>
          </div>
        }
      </div>

      @if (enquiry?.type !== EnumEnquiryType.cargo) {
        <div class="row justify-content-center">
          <div class="col-md-4">
            <div class="form-group">
              <label
                for="aircraftHasToilet"
                [innerText]="'FLIGHT_BRIEF.WC' | translate"
              ></label>
              <select
                class="form-select"
                id="aircraftHasToilet"
                formControlName="aircraftHasToilet"
                            [class.is-invalid]="
                                (form.touched || aircraftHasToilet.touched) &&
                                aircraftHasToilet.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
                >
                <option
                  [ngValue]="true"
                  [innerText]="'GENERAL.YES' | translate"
                ></option>
                <option
                  [ngValue]="false"
                  [innerText]="'GENERAL.NO' | translate"
                ></option>
              </select>
              <div class="invalid-tooltip">
                @if (
                  (form.touched || aircraftHasToilet.touched) &&
                  aircraftHasToilet.errors &&
                  aircraftHasToilet.errors['required']
                  ) {
                  <div
                    [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                  ></div>
                }
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label
                for="smokingIsAllowed"
                [innerText]="'FLIGHT_BRIEF.SMOKING' | translate"
              ></label>
              <select
                class="form-select"
                id="smokingIsAllowed"
                formControlName="smokingIsAllowed"
                            [class.is-invalid]="
                                (form.touched || smokingIsAllowed.touched) &&
                                smokingIsAllowed.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
                >
                <option
                  [ngValue]="true"
                  [innerText]="'GENERAL.YES' | translate"
                ></option>
                <option
                  [ngValue]="false"
                  [innerText]="'GENERAL.NO' | translate"
                ></option>
              </select>
              <div class="invalid-tooltip">
                @if (
                  (form.touched || smokingIsAllowed.touched) &&
                  smokingIsAllowed.errors &&
                  smokingIsAllowed.errors['required']
                  ) {
                  <div
                    [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                  ></div>
                }
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label
                for="capacityMax"
                [innerText]="'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.CAPACITY_MAX' | translate"
              ></label>
              <div class="input-group">
                <input
                  type="number"
                  class="form-control"
                  id="capacityMax"
                  formControlName="capacityMax"
                                [class.is-invalid]="
                                    (form.touched || capacityMax.touched) &&
                                    capacityMax.status === 'INVALID'
                                        ? 'danger'
                                        : ''
                                "
                  />
                <div class="invalid-tooltip">
                  @if (
                    (form.touched || capacityMax.touched) &&
                    capacityMax.errors &&
                    capacityMax.errors['required']
                    ) {
                    <div
                      [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                    ></div>
                  }
                </div>
                <span class="input-group-text">pax</span>
              </div>
            </div>
          </div>
        </div>
      }

      @if (form.value.airlineId) {
        <div class="d-flex justify-content-center">
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              id="displayAirlineOnFlightBrief"
              formControlName="displayAirlineOnFlightBrief"
              />
            <label
              class="form-check-label"
              for="displayAirlineOnFlightBrief"
                        [innerText]="
                            'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.DISPLAY_AIRLINE_ON_FLIGHT_BRIEF'
                                | translate
                        "
            ></label>
          </div>
        </div>
      }
    </div>
  </div>

  @if (aircraftModelId.value) {
    <section class="card aircraft-brief-photos mb-4">
      <div class="card-header">
        <div class="fw-semibold" [innerText]="'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.FLIGHT_BRIEF_PHOTOS' | translate"></div>
        <div class="small text-muted mt-1" [innerText]="'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.FLIGHT_BRIEF_PHOTOS_HELP' | translate"></div>
      </div>
      <div class="card-body">
        <div class="row g-3">
          @for (imageField of ['imageOutside', 'imageInside']; track imageField) {
            <div class="col-lg-6">
              <article class="aircraft-photo-slot h-100">
                <div class="d-flex align-items-center justify-content-between gap-2 mb-3">
                  <h3 class="h6 mb-0">
                    {{
                      (imageField === 'imageOutside'
                        ? 'FLIGHT_BRIEF.PHOTO_OUTSIDE'
                        : 'FLIGHT_BRIEF.PHOTO_INSIDE') | translate
                    }}
                  </h3>
                  @if (form.get(imageField + 'Url')?.value) {
                    <span
                      class="badge text-bg-light aircraft-photo-source"
                      [innerText]="getBriefImageSourceKey($any(imageField)) | translate"
                    ></span>
                  }
                </div>

                @if (form.get(imageField + 'Url')?.value) {
                  <div class="aircraft-photo-preview rounded mb-3">
                    <img
                      [src]="form.get(imageField + 'Url')?.value"
                      [attr.alt]="imageField === 'imageOutside'
                        ? ('FLIGHT_BRIEF.PHOTO_OUTSIDE' | translate)
                        : ('FLIGHT_BRIEF.PHOTO_INSIDE' | translate)"
                      [style.transform]="'scale(' + form.get(imageField + 'ZoomLevel')?.value + ')'"
                    />
                  </div>
                  <div class="d-flex align-items-center justify-content-between gap-3">
                    <button
                      type="button"
                      class="btn btn-sm btn-primary"
                      (click)="openBriefImageModal($any(imageField))"
                    >
                      <fa-icon class="me-2" [icon]="faImage" aria-hidden="true"></fa-icon>
                      {{ 'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.CHANGE_PHOTO' | translate }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-link text-danger text-decoration-none p-0"
                      (click)="deleteBriefImage($any(imageField))"
                    >
                      <fa-icon class="me-1" [icon]="faTrashCan" aria-hidden="true"></fa-icon>
                      {{ 'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.REMOVE_PHOTO' | translate }}
                    </button>
                  </div>
                } @else {
                  <div class="aircraft-photo-empty rounded text-center">
                    <div
                      class="text-muted mb-3"
                      [innerText]="
                        (imageField === 'imageOutside'
                          ? 'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.NO_OUTSIDE_PHOTO'
                          : 'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.NO_INSIDE_PHOTO') | translate
                      "
                    ></div>
                    <button
                      type="button"
                      class="btn btn-sm btn-primary"
                      (click)="openBriefImageModal($any(imageField))"
                    >
                      <fa-icon class="me-2" [icon]="faImage" aria-hidden="true"></fa-icon>
                      {{ 'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.CHOOSE_PHOTO' | translate }}
                    </button>
                  </div>
                }
              </article>
            </div>
          }
        </div>
      </div>
    </section>
  }

<div class="row mb-4">
  <div class="col"></div>
  <div class="col text-end">
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="form.disabled || !form.valid"
      (click)="saveAndNext()"
      >
      {{ "GENERAL.NEXT" | translate }}
      <fa-icon [icon]="faArrowRight"></fa-icon>
    </button>
  </div>
</div>
</form>

<div class="modal" tabindex="-1" role="dialog" #modalBriefImage>
  <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ 'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.CHOOSE_PHOTO' | translate }} ·
          {{
            (selectedBriefImageField === 'imageOutside'
              ? 'FLIGHT_BRIEF.PHOTO_OUTSIDE'
              : 'FLIGHT_BRIEF.PHOTO_INSIDE') | translate
          }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'GENERAL.CLOSE' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <div class="aircraft-photo-upload rounded mb-4">
          <div>
            <div class="fw-semibold" [innerText]="'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.CUSTOM_IMAGE' | translate"></div>
            <div class="small text-muted" [innerText]="'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.UPLOAD_HELP' | translate"></div>
          </div>
          <app-file-input #briefImageFileInput class="flex-grow-1" labelKey="GENERAL.FILE_INPUT.IMAGE" accept="image/*"
            [disabled]="form.disabled" (fileSelected)="changeBriefImageFile($event, $any(selectedBriefImageField))"></app-file-input>
        </div>

        @if (aircraftBriefImageCandidates.length) {
          <section class="mb-4">
            <h6 [innerText]="'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.AIRCRAFT_AVAILABLE_IMAGES' | translate"></h6>
            <div class="row g-3">
              @for (candidate of aircraftBriefImageCandidates; track candidate.url) {
                <div class="col-sm-6 col-lg-4">
                  <div class="aircraft-photo-candidate h-100 rounded">
                    <div class="aircraft-photo-candidate-preview rounded">
                      <img [src]="candidate.url" [attr.alt]="'GENERAL.IMAGE' | translate" />
                    </div>
                    @if (candidate.labelKeys.length) {
                      <div class="d-flex flex-wrap gap-1 mt-2">
                        @for (labelKey of candidate.labelKeys; track labelKey) {
                          <span class="badge text-bg-secondary" [innerText]="labelKey | translate"></span>
                        }
                      </div>
                    }
                    <button
                      type="button"
                      class="btn btn-sm btn-primary w-100 mt-3"
                      [disabled]="form.disabled"
                      (click)="useBriefImage(candidate.url)"
                    >
                      <fa-icon class="me-2" [icon]="faCheck" aria-hidden="true"></fa-icon>
                      {{ 'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.USE_THIS_PHOTO' | translate }}
                    </button>
                  </div>
                </div>
              }
            </div>
          </section>
        }

        @if (modelBriefImageCandidates.length) {
          <section class="mb-4">
            <h6 [innerText]="'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.MODEL_AVAILABLE_IMAGES' | translate"></h6>
            <div class="row g-3">
              @for (candidate of modelBriefImageCandidates; track candidate.url) {
                <div class="col-sm-6 col-lg-4">
                  <div class="aircraft-photo-candidate h-100 rounded">
                    <div class="aircraft-photo-candidate-preview rounded">
                      <img [src]="candidate.url" [attr.alt]="'GENERAL.IMAGE' | translate" />
                    </div>
                    @if (candidate.labelKeys.length) {
                      <div class="d-flex flex-wrap gap-1 mt-2">
                        @for (labelKey of candidate.labelKeys; track labelKey) {
                          <span class="badge text-bg-secondary" [innerText]="labelKey | translate"></span>
                        }
                      </div>
                    }
                    <button
                      type="button"
                      class="btn btn-sm btn-primary w-100 mt-3"
                      [disabled]="form.disabled"
                      (click)="useBriefImage(candidate.url)"
                    >
                      <fa-icon class="me-2" [icon]="faCheck" aria-hidden="true"></fa-icon>
                      {{ 'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.USE_THIS_PHOTO' | translate }}
                    </button>
                  </div>
                </div>
              }
            </div>
          </section>
        }

        @if (!briefImageCandidates.length) {
          <div
            class="aircraft-photo-empty rounded text-center text-muted mb-4"
            [innerText]="'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.NO_SOURCE_IMAGES' | translate"
          ></div>
        }

        @if (
          (selectedAircraft?.id && hasAclAccess(EnumAcl.aircraftsEdit)) ||
          (selectedAircraftModel?.id && hasAclAccess(EnumAcl.aircraftModelsEdit))
        ) {
          <section class="aircraft-photo-management border-top pt-3">
            <div class="small fw-semibold mb-2" [innerText]="'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.MANAGE_SOURCE_IMAGES' | translate"></div>
            <div class="d-flex flex-wrap gap-2">
              @if (selectedAircraft?.id && hasAclAccess(EnumAcl.aircraftsEdit)) {
                <button
                  type="button"
                  class="btn btn-sm btn-outline-secondary"
                  (click)="navigateToAircraftEdit($safeNavigationMigration(selectedAircraft?.id))"
                >
                  <fa-icon [icon]="faEdit"></fa-icon>
                  {{ 'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.EDIT_AIRCRAFT_IMAGES' | translate }}
                </button>
              }
              @if (selectedAircraftModel?.id && hasAclAccess(EnumAcl.aircraftModelsEdit)) {
                <button
                  type="button"
                  class="btn btn-sm btn-outline-secondary"
                  (click)="navigateToAircraftModelEdit($safeNavigationMigration(selectedAircraftModel?.id))"
                >
                  <fa-icon [icon]="faEdit"></fa-icon>
                  {{ 'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.EDIT_MODEL_IMAGES' | translate }}
                </button>
              }
            </div>
          </section>
        }
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
          [innerText]="'GENERAL.CLOSE' | translate"
        ></button>
      </div>
    </div>
  </div>
</div>

<form (submit)="saveAircraft()" [formGroup]="formAircraft" (keydown.enter)="saveAircraft()">
  <div class="modal" tabindex="-1" role="dialog" id="modal-aircraft-add" #modalAircraftAdd>
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
            [innerText]="'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.ADD_NEW_AIRCRAFT' | translate"
          ></h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            [attr.aria-label]="'GENERAL.CLOSE' | translate"
          ></button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label
              for="serialNumber"
              [innerText]="'ENQUIRY_FLIGHT_EDIT.AIRCRAFT.MSN' | translate"
            ></label>
            <input
              class="form-control"
              id="serialNumber"
              formControlName="serialNumber"
              type="text"
                            [class.is-invalid]="
                                (formAircraft.touched ||
                                    formAircraft.controls['serialNumber'].touched) &&
                                formAircraft.controls['serialNumber'].status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />

            <div class="invalid-tooltip">
              @if (
                (formAircraft.touched ||
                formAircraft.controls['serialNumber'].touched) &&
                formAircraft.controls['serialNumber'].errors &&
                formAircraft.controls['serialNumber'].errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
          <div class="form-group">
            <label for="status" [innerText]="'GENERAL.STATUS' | translate"></label>
            <select
              class="form-select"
              id="status"
              formControlName="status"
              required
                            [class.is-invalid]="
                                (formAircraft.touched || formAircraft.controls['status'].touched) &&
                                formAircraft.controls['status'].status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              >
              @for (status of getAircraftStatuses(); track status) {
                <option
                  [value]="status"
                  [innerText]="getAircraftStatusLabel(status)"
                ></option>
              }
            </select>

            <div class="invalid-tooltip">
              @if (
                (formAircraft.touched ||
                formAircraft.controls['status'].touched) &&
                formAircraft.controls['status'].errors &&
                formAircraft.controls['status'].errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
          <div class="form-group">
            <label
              for="registration"
              [innerText]="'FLIGHT_BRIEF.REGISTRATION' | translate"
            ></label>
            <input
              class="form-control"
              id="registration"
              formControlName="registration"
              type="text"
                            [class.is-invalid]="
                                (formAircraft.touched ||
                                    formAircraft.controls['registration'].touched) &&
                                formAircraft.controls['registration'].status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />

            <div class="invalid-tooltip">
              @if (
                (formAircraft.touched ||
                formAircraft.controls['registration'].touched) &&
                formAircraft.controls['registration'].errors &&
                formAircraft.controls['registration'].errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            [innerText]="'GENERAL.CANCEL' | translate"
          ></button>
          <button
            type="button"
            class="btn btn-primary"
            (click)="saveAircraft()"
            [disabled]="formAircraft.disabled || !formAircraft.valid"
            [innerText]="'GENERAL.SAVE' | translate"
          ></button>
        </div>
      </div>
    </div>
  </div>
</form>
